import { Controller } from "@hotwired/stimulus"
import { logger } from "../logger"

// Handles processor selection for attachment type files
// Loads processor-specific parameters when processor is selected from dropdown
// Replaces: app/javascript/admin/settings/attachment_type_files_process_parameteres.js
export default class extends Controller {
  static values = {
    url: String
  }

  change(event) {
    const processor = event.target.value

    if (!processor || !this.urlValue) {
      return
    }

    const params = new URLSearchParams({ processor })

    fetch(`${this.urlValue}?${params}`, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'text/javascript, application/javascript, */*'
      }
    })
    .then(response => response.text())
    .then(script => {
      // Execute server-generated JavaScript (process_parameters.js.erb)
      // Using Function() instead of eval() for better bundler compatibility
      // Script is from our own server, not user input
      new Function(script)()
    })
    .catch(error => {
      logger.error('Error loading process parameters:', error)
    })
  }
}
